import {Component, input, output} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard-item',
  templateUrl: './dashboard-item.component.html',
  styleUrls: ['./dashboard-item.component.css'],
  standalone: false
})
export class DashboardItemComponent {
  iconSvg = input.required<SafeHtml>();
  title = input.required<string>();
  mainValue = input.required<number | string>();
  chartData = input<{ value: number; name: string }[]>();
  entityName = input<string>();
  isEmpty = input<boolean>(false);
  clickable = input<boolean>(false);
  cardClick = output();

  onClick() {
    if (this.clickable()) {
      this.cardClick.emit();
    }
  }
}
